import { render, staticRenderFns } from "./FootprintBunge.vue?vue&type=template&id=3115a964&lang=pug"
import script from "./FootprintBunge.vue?vue&type=script&lang=js"
export * from "./FootprintBunge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports